var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { ImxPendingBurnStatus } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useEffect, useState } from 'react';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { appEnv } from '../../env';
import { DialogType } from '../../types/dialogs';
import { sleep } from '../../utils/async';
import { useImxActions } from '../imx/use-imx-actions';
export function usePendingUse(pendingTransferUuid) {
    var t = useI18n().t;
    var _a = useContext(LoadingContext), serverLoading = _a.serverLoading, setServerLoading = _a.setServerLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var selectedWallet = useContext(UserContext).selectedWallet;
    var _b = useState(undefined), pendingTransferState = _b[0], setPendingTransferState = _b[1];
    var _c = useState(undefined), pendingTransferStatus = _c[0], setPendingTransferStatus = _c[1];
    var imxActions = useImxActions();
    useEffect(function () {
        function init() {
            return __awaiter(this, void 0, void 0, function () {
                var blockchainPendingCtaTtokenTransferFindOne, ctaTokenCountToTransferFormated, ctaTokenCountToTransferDeci18, ctaTokenCountTransferedFormated, ctaTokenCountTransferedDeci18, recipientWalletAddress, isExternalDone, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            setServerLoading(true);
                            if (!(pendingTransferState === undefined)) return [3 /*break*/, 4];
                            if (!pendingTransferUuid) {
                                setPendingTransferState(null);
                                setPendingTransferStatus(undefined);
                                return [2 /*return*/];
                            }
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, gqlSdk.BlockchainPendingCtaTtokenTransferFindOne({
                                    input: { pendingCtaTokenTransferUuid: pendingTransferUuid },
                                })];
                        case 2:
                            blockchainPendingCtaTtokenTransferFindOne = (_b.sent()).blockchainPendingCtaTtokenTransferFindOne;
                            if (!blockchainPendingCtaTtokenTransferFindOne) {
                                setPendingTransferState(null);
                            }
                            else {
                                ctaTokenCountToTransferFormated = blockchainPendingCtaTtokenTransferFindOne.ctaTokenCountToTransferFormated, ctaTokenCountToTransferDeci18 = blockchainPendingCtaTtokenTransferFindOne.ctaTokenCountToTransferDeci18, ctaTokenCountTransferedFormated = blockchainPendingCtaTtokenTransferFindOne.ctaTokenCountTransferedFormated, ctaTokenCountTransferedDeci18 = blockchainPendingCtaTtokenTransferFindOne.ctaTokenCountTransferedDeci18, recipientWalletAddress = blockchainPendingCtaTtokenTransferFindOne.recipientWalletAddress, isExternalDone = blockchainPendingCtaTtokenTransferFindOne.isExternalDone;
                                setPendingTransferState({
                                    ctaTokenCountToTransferFormated: ctaTokenCountToTransferFormated,
                                    ctaTokenCountToTransferDeci18: ctaTokenCountToTransferDeci18,
                                    ctaTokenCountTransferedFormated: ctaTokenCountTransferedFormated,
                                    ctaTokenCountTransferedDeci18: ctaTokenCountTransferedDeci18,
                                    recipientWalletAddress: recipientWalletAddress,
                                    isExternalDone: isExternalDone,
                                });
                                setPendingTransferStatus(ImxPendingBurnStatus.PENDING);
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            _a = _b.sent();
                            setPendingTransferState(null);
                            setPendingTransferStatus(undefined);
                            return [3 /*break*/, 4];
                        case 4:
                            setServerLoading(false);
                            return [2 /*return*/];
                    }
                });
            });
        }
        init();
    }, [pendingTransferState, pendingTransferUuid]);
    function transferPendingTransfer() {
        return __awaiter(this, void 0, void 0, function () {
            var ctaTokenCountToTransferDeci18, ctaTokenCountTransferedDeci18, recipientWalletAddress, remainingTransferCount, error, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedWallet || !pendingTransferUuid || !pendingTransferState || serverLoading)
                            return [2 /*return*/];
                        setPendingTransferStatus(ImxPendingBurnStatus.PROCESSING);
                        ctaTokenCountToTransferDeci18 = pendingTransferState.ctaTokenCountToTransferDeci18, ctaTokenCountTransferedDeci18 = pendingTransferState.ctaTokenCountTransferedDeci18, recipientWalletAddress = pendingTransferState.recipientWalletAddress;
                        remainingTransferCount = BigInt(ctaTokenCountToTransferDeci18) - BigInt(ctaTokenCountTransferedDeci18);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, imxActions.transferERC20({
                                toAddress: recipientWalletAddress,
                                tokenAddress: appEnv.ctaTokenAddress,
                                quantity: "".concat(remainingTransferCount.toString(), "00000000"),
                                walletFrom: selectedWallet,
                            })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, gqlSdk.BlockchainPendingCtaTtokenTransferSetDone({
                                input: { pendingCtaTokenTransferUuid: pendingTransferUuid },
                            })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        if (err_1 instanceof Error) {
                            error = t('error.generic');
                            console.log("[transferPendingTransfer] ".concat(err_1));
                        }
                        return [3 /*break*/, 5];
                    case 5: 
                    // This is the delay needed for our poller to catch up, let's make them wait a little bit more on the web
                    return [4 /*yield*/, sleep(5000)];
                    case 6:
                        // This is the delay needed for our poller to catch up, let's make them wait a little bit more on the web
                        _a.sent();
                        setDialogProps(error
                            ? {
                                common: {
                                    title: t('common.error'),
                                    close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                                },
                                custom: {
                                    type: DialogType.SIMPLE,
                                    message: error,
                                },
                            }
                            : undefined);
                        setPendingTransferStatus(ImxPendingBurnStatus.COMPLETED);
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        pendingTransferState: pendingTransferState,
        pendingTransferStatus: pendingTransferStatus,
        transferPendingTransfer: transferPendingTransfer,
    };
}
